export const COLORS = {
  default: [
    "#5a7bfc",
    "#f78e61",
    "#bca9ea",
    "#ea90b1",
    "#82c0fd",
    "#9ADFB4",
    "#2E7987",
    "#FFDAC1",
    "#E7E8D1",
    "#C4C4C4",
    "#F4BFBF",
    "#FFD3B6",
    "#E2F0CB",
    "#FF6961",
    "#77DD77",
    "#AEC6CF",
    "#B39EB5",
    "#6A89FE",
    "#F79A72",
    "#C1B2F0",
    "#EBA1C0",
    "#8AC7FF",
    "#A3E6C1",
    "#398A99",
    "#FFE1C8",
    "#EEF1D5",
    "#CCCCCC",
    "#F8C2C2",
    "#FFD8BD",
    "#E7F4D6",
    "#FF7D73",
    "#88E088",
    "#B4D2E8",
    "#C2A6D6",
    "#5F84FF",
    "#FA7C55",
    "#D2B5F5",
    "#E67FA4",
    "#79B7F9",
    "#8FE6AD",
    "#256E7C",
    "#FFD9B9",
    "#DBDDC4",
    "#BBBBBB",
    "#F2A9A9",
    "#FFC9A9",
    "#D8EFC2",
    "#FF5F5F",
    "#6FD96F",
    "#99BCD6",
    "#A88EB0",
    "#6B94FF",
    "#F98A6B",
    "#C6A1E5",
    "#D986A6",
    "#7ABFFD",
    "#A8F1C2",
    "#3D8B99",
    "#FFEDCF",
    "#F0F1D9",
    "#D1D1D1",
    "#F7D1D1",
    "#FFE4CD",
    "#E9F8D9",
    "#FF8282",
    "#94E094",
    "#AFCFE8",
    "#BBA0C6",
    "#759AFF",
    "#FC9C7F",
    "#D8BDF7",
    "#F091B1",
    "#89CFFF",
    "#A9EFCB",
    "#4C9EB1",
    "#FFE7D1",
    "#F4F5E1",
    "#DDDDDD",
    "#F9E2E2",
    "#FFEBD5",
    "#ECFADD",
    "#FF9F9F",
    "#A2E5A2",
    "#C3E1F7",
    "#D1B8E5",
    "#81A5FF",
    "#FBA588",
    "#E1C7F9",
    "#F3A1C6",
    "#96D2FF",
    "#B2F6D5",
    "#5EAFBE",
    "#FFF0DA",
    "#FAFBE8",
    "#EAEAEA",
    "#FDEAEA",
    "#FFF3E0",
    "#F2FEEA",
    "#FFB3B3",
    "#B5F3B5",
    "#D1ECF8",
    "#E1CFF2",
    "#8BB1FF",
  ],
  orange: [
    "#904233",
    "#a75645",
    "#b86554",
    "#cf7a67",
    "#e78f7b",
    "#ffa490",
    "#FFC3A3",
    "#FF8C00",
    "#E9967A",
    "#FFA07A",
    "#FF7F50",
    "#FF6347",
    "#FF4500",
    "#FFD700",
    "#FFA500",
    "#FF8C00",
    "#FF7500",
  ],
  aqua: [
    "#136c71",
    "#00747a",
    "#00a1a7",
    "#00a1a7",
    "#29b7bd",
    "#49cdd3",
    "#7ce8ee",
    "#00CED1",
    "#40E0D0",
    "#48D1CC",
    "#20B2AA",
    "#5F9EA0",
    "#4682B4",
    "#B0E0E6",
    "#AFEEEE",
    "#ADD8E6",
    "#87CEEB",
  ],
  purple: [
    "#63548b",
    "#6f5f9a",
    "#8472af",
    "#9a87c5",
    "#af9cdc",
    "#c6b1f2",
    "#ddc8ff",
    "#E6E6FA",
    "#D8BFD8",
    "#DDA0DD",
    "#DA70D6",
    "#BA55D3",
    "#9932CC",
    "#8A2BE2",
    "#9400D3",
    "#8B008B",
    "#800080",
  ],
  yellow: [
    "#d8a045",
    "#df9419",
    "#eca531",
    "#f5b44b",
    "#fec76f",
    "#ffd28a",
    "#ffd28a",
    "#FFFFE0",
    "#FFFACD",
    "#FAFAD2",
    "#FFEFD5",
    "#FFE4B5",
    "#FFDAB9",
    "#EEE8AA",
    "#F0E68C",
    "#BDB76B",
    "#FFD700",
  ],
  blue: [
    "#0d6294",
    "#186da3",
    "#3981b9",
    "#5296cf",
    "#6aabe6",
    "#81c1fd",
    "#a9ddff",
    "#1E90FF",
    "#6495ED",
    "#00BFFF",
    "#87CEFA",
    "#ADD8E6",
    "#B0E0E6",
    "#5F9EA0",
    "#4682B4",
    "#4169E1",
    "#0000FF",
  ],
  green: [
    "#517846",
    "#457337",
    "#59884a",
    "#6e9d5d",
    "#83b271",
    "#98c886",
    "#aedf9b",
    "#ADFF2F",
    "#7FFF00",
    "#7CFC00",
    "#00FF00",
    "#32CD32",
    "#98FB98",
    "#90EE90",
    "#00FA9A",
    "#00FF7F",
    "#3CB371",
  ],
};

export const COMPARISON_COLORS = {
  aqua: [
    "#fea58e",
    "#49cdd3",
    "#bca9ea",
    "#ea90b1",
    "#82c0fd",
    "#9ADFB4",
    "#2E7987",
    "#FFDAC1",
    "#E7E8D1",
    "#C4C4C4",
    "#F4BFBF",
    "#FFD3B6",
    "#E2F0CB",
    "#FF6961",
    "#77DD77",
    "#AEC6CF",
    "#B39EB5",
  ],
  green: [
    "#904233",
    "#a75645",
    "#b86554",
    "#cf7a67",
    "#e78f7b",
    "#ffa490",
    "#FFC3A3",
    "#FF8C00",
    "#E9967A",
    "#FFA07A",
    "#FF7F50",
    "#FF6347",
    "#FF4500",
    "#FFD700",
    "#FFA500",
    "#FF8C00",
    "#FF7500",
  ],
  blue: [
    "#136c71",
    "#00747a",
    "#00a1a7",
    "#00a1a7",
    "#29b7bd",
    "#49cdd3",
    "#7ce8ee",
    "#00CED1",
    "#40E0D0",
    "#48D1CC",
    "#20B2AA",
    "#5F9EA0",
    "#4682B4",
    "#B0E0E6",
    "#AFEEEE",
    "#ADD8E6",
    "#87CEEB",
  ],
  purple: [
    "#63548b",
    "#6f5f9a",
    "#8472af",
    "#9a87c5",
    "#af9cdc",
    "#c6b1f2",
    "#ddc8ff",
    "#E6E6FA",
    "#D8BFD8",
    "#DDA0DD",
    "#DA70D6",
    "#BA55D3",
    "#9932CC",
    "#8A2BE2",
    "#9400D3",
    "#8B008B",
    "#800080",
  ],
  yellow: [
    "#0d6294",
    "#186da3",
    "#3981b9",
    "#5296cf",
    "#6aabe6",
    "#81c1fd",
    "#a9ddff",
    "#1E90FF",
    "#6495ED",
    "#00BFFF",
    "#87CEFA",
    "#ADD8E6",
    "#B0E0E6",
    "#5F9EA0",
    "#4682B4",
    "#4169E1",
    "#0000FF",
  ],
  default: [
    "#0d6294",
    "#186da3",
    "#3981b9",
    "#5296cf",
    "#6aabe6",
    "#81c1fd",
    "#a9ddff",
    "#1E90FF",
    "#6495ED",
    "#00BFFF",
    "#87CEFA",
    "#ADD8E6",
    "#B0E0E6",
    "#5F9EA0",
    "#4682B4",
    "#4169E1",
    "#0000FF",
  ],
  orange: [
    "#517846",
    "#457337",
    "#59884a",
    "#6e9d5d",
    "#83b271",
    "#98c886",
    "#aedf9b",
    "#ADFF2F",
    "#7FFF00",
    "#7CFC00",
    "#00FF00",
    "#32CD32",
    "#98FB98",
    "#90EE90",
    "#00FA9A",
    "#00FF7F",
    "#3CB371",
  ],
};
